import { connect } from 'react-redux';
import SearchProducts from 'swag-client-common/components/info/search-products';
import { searchProductsSelector } from '../../../redux/search-products/search-products.selectors';
import { searchProductsDispatcher } from '../../../redux/search-products/search-products.dispatchers';
export default connect(searchProductsSelector, searchProductsDispatcher)(SearchProducts);